import React, { useCallback, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import ImagePlaceholder from '../../../../../../features/components/ImagePlaceholder'

import { showToasts } from '../../../../../../helpers/toasts'

import { TOAST_TYPE } from '../../../../../../constants/other'

const ImageAssetPreview = ({ containerWidth, fileUrl, width, height, backgroundColor, arrowColor }) => {
  const [isMediaLoaded, setIsMediaLoaded] = useState(false)
  const [isMediaFailed, setIsMediaFailed] = useState(false)

  const handleMediaSuccessfullyLoaded = useCallback(() => setIsMediaLoaded(true), [])
  const handleMediaFailed = useCallback(() => setIsMediaFailed(true), [])

  const displayImage = useMemo(() => {
    return isMediaLoaded ? 'block' : 'none'
  }, [isMediaLoaded])

  // On file remove - set isMediaLoaded and isMediaFailed to false
  useEffect(() => {
    if (!fileUrl) {
      setIsMediaLoaded(false)
      setIsMediaFailed(false)
    }
  }, [fileUrl])

  // In some cases (adBlocker, bad internet connection) getting image by url may fail,
  // In this case we show imagePlaceholder and show toast with info message
  useEffect(() => {
    if (isMediaFailed) {
      showToasts({
        type: TOAST_TYPE.error,
        message: 'Oops, something went wrong, please check your internet connection, turn off ad blocker, and try again'
      })
    }
  }, [isMediaFailed])

  if (!fileUrl) {
    return (
      <ImagePlaceholder
        containerWidth={containerWidth}
        width={width}
        height={height}
        backgroundColor={backgroundColor}
        arrowColor={arrowColor}
      />
    )
  }

  return (
    <>
      <img
        onLoad={handleMediaSuccessfullyLoaded}
        // If media is not loaded - we set 'display: none', and show ImagePlaceholder
        style={{ display: displayImage }}
        src={fileUrl}
        alt="Uploaded asset"
        onError={handleMediaFailed}
      />
      {isMediaFailed && (
        <ImagePlaceholder
          containerWidth={containerWidth}
          width={width}
          height={height}
          isImageFailed
          backgroundColor={backgroundColor}
          arrowColor={arrowColor}
        />
      )}
    </>
  )
}

ImageAssetPreview.propTypes = {
  containerWidth: PropTypes.number,
  fileUrl: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  backgroundColor: PropTypes.string,
  arrowColor: PropTypes.string
}

export default ImageAssetPreview
